import { NumericFormatField } from '@/components';
import { useProjectFormContext } from '@/features/project/_hooks/form-context';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  hint?: string;
};

export const SortOrderField: FC<Props> = ({ hint }) => {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
  } = useProjectFormContext();

  return (
    <NumericFormatField
      key="data.sortOrder"
      name="data.sortOrder"
      control={control}
      label={t('project-order-number')}
      errors={errors}
      disableSeparator
      maxLength={4}
      marginBottom={0}
      hint={hint}
    />
  );
};
